import { c as _c } from "react/compiler-runtime";
import { cn } from "@repo/ui/utils";
import { Overline } from "@repo/ui/overline";
import { SolidShape } from "@repo/ui/solid-shape";
import { RichTextBodyCopySimple } from "@/components/common/rich-text/rich-text-body-copy-simple.component";
import type { BigStatementProps } from "./big-statement.types";
const spacingVariants = {
  default: "pt-20 pb-16 desktop:py-40",
  loose: "pt-24 pb-12 desktop:pt-48 desktop:pb-28",
  compact: "pt-6 pb-10 desktop:pt-10 desktop:pb-16"
} as const;
export function BigStatement(t0) {
  const $ = _c(24);
  const {
    overline,
    statement,
    underlineItems,
    spacing: t1,
    className,
    sans: t2
  } = t0;
  const spacing = t1 === undefined ? "default" : t1;
  const sans = t2 === undefined ? false : t2;
  let t3;
  if ($[0] !== className) {
    t3 = cn("bg-surface-base-primary rounded-t-md desktop:rounded-t-xl overflow-clip", className);
    $[0] = className;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const t4 = spacingVariants[spacing];
  let t5;
  if ($[2] !== t4) {
    t5 = cn("container-grid", t4);
    $[2] = t4;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  const t6 = sans ? "gap-4" : "gap-6 desktop:gap-12";
  let t7;
  if ($[4] !== t6) {
    t7 = cn("col-span-full flex flex-col items-center desktop:max-w-[866px] mx-auto", t6);
    $[4] = t6;
    $[5] = t7;
  } else {
    t7 = $[5];
  }
  let t8;
  if ($[6] !== overline) {
    t8 = overline && <Overline>{overline}</Overline>;
    $[6] = overline;
    $[7] = t8;
  } else {
    t8 = $[7];
  }
  const t9 = sans ? "heading" : "heading-serif";
  let t10;
  if ($[8] !== statement || $[9] !== t9) {
    t10 = <RichTextBodyCopySimple richText={statement} as={t9} className="text-text-primary text-center" />;
    $[8] = statement;
    $[9] = t9;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  if ($[11] !== underlineItems) {
    t11 = underlineItems && underlineItems.length > 0 && <div className="flex items-center gap-2 text-text-secondary">{underlineItems.map(_temp)}</div>;
    $[11] = underlineItems;
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  let t12;
  if ($[13] !== t10 || $[14] !== t11 || $[15] !== t7 || $[16] !== t8) {
    t12 = <div className={t7}>{t8}{t10}{t11}</div>;
    $[13] = t10;
    $[14] = t11;
    $[15] = t7;
    $[16] = t8;
    $[17] = t12;
  } else {
    t12 = $[17];
  }
  let t13;
  if ($[18] !== t12 || $[19] !== t5) {
    t13 = <div className={t5}>{t12}</div>;
    $[18] = t12;
    $[19] = t5;
    $[20] = t13;
  } else {
    t13 = $[20];
  }
  let t14;
  if ($[21] !== t13 || $[22] !== t3) {
    t14 = <section className={t3} data-testid="big-statement">{t13}</section>;
    $[21] = t13;
    $[22] = t3;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  return t14;
}
function _temp(item, index) {
  return <div key={`${index}-${item}`} className="flex items-center gap-2">{index > 0 && <SolidShape variant="circle" color="afternoon" animated={false} className="size-2" />}<span className="typography-body-xs-medium desktop:typography-body-sm-medium">{item}</span></div>;
}